import { Component, ViewChild, OnInit, AfterViewInit, OnDestroy, Directive, Input, Output, EventEmitter, ElementRef, Renderer } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'custom-dialog',
    templateUrl: './custom-dialog.component.html',
    styleUrls: ['./custom-dialog.component.scss']
})
export class CustomDialogComponent implements OnInit {
    private config: MatDialogConfig = <MatDialogConfig>{};
    private _defaults = {
        title: 'Dialog',
        closeText: 'Close',
        applyText: 'Apply',
        maxHeight: 240,
        disableCloseOnScreen: false
    };

    dialogRef: MatDialogRef<CustomDialogComponent>;

    @Input('close-text') closeText: string = this._defaults.closeText;
    @Input('apply-text') applyText: string = this._defaults.applyText;
    @Input('disable-close-onScreen') disableCloseOnScreen: boolean = this._defaults.disableCloseOnScreen;
    @Input('title') title: string = this._defaults.title;
    @Input('referenceId') referenceId: number = null;
    @Input('heading') heading: string;
    @Input('applyDisabled') applyDisabled: boolean;
    @Input('closeDisabled') closeDisabled: boolean;
    @Input('applyShown') applyShown: boolean;
    @Input('closeShown') closeShown: boolean;
    @Input('max-width') maxWidth: string = '450px';
    @Input('min-width') minWidth: string = '380px';
    @Input('min-height') minHeight: string = '180px';
    @Input('max-height') maxHeight: string = this._defaults.maxHeight + 'px';
    @Input('disableCloseOnOutside') disableCloseOnOutside: boolean = false;

    @Output('applyClick') applyClick: EventEmitter<number> = new EventEmitter<number>();
    @Output('closeClick') closeClick: EventEmitter<number> = new EventEmitter<number>();

    @ViewChild('dialogTemplate') template: any;

    constructor(public dialog: MatDialog, public dialogElement: ElementRef) {
    }

    ngOnInit() {
        this.config = {
            width: this.maxWidth,
            height: 'auto',
            minWidth: this.minWidth,
            maxWidth: this.maxWidth,
            minHeight: this.minHeight,
            maxHeight: this.maxHeight,
            disableClose: this.disableCloseOnOutside
        };
    }

    getCloseButtonColor = () => {
        return this.applyShown ? "" : "primary";
    }

    activate(position?: any) {
        if (this.dialogRef) return; // if dialog exists, return.
        if (window.innerHeight < this._defaults.maxHeight) { // if window height < _default.maxHeight
            this.config.height = window.innerHeight.toString() + 'px';
        }
        this.config.disableClose = this.disableCloseOnOutside;
        //window.setTimeout(() => {
        this.dialogRef = this.dialog.open(this.template, this.config);
        // update position
        if (position) {
            this.dialogRef.updatePosition(position);
        }
        // handle afterClosed()
        this.dialogRef.beforeClose().subscribe(() => {
            this.dialogRef = undefined;
        });
        //}); // todo: find a better solution then setTimeOut()
    };

    onResize = (event: any) => {
        const containerHeight: any = (<any>(this.dialogRef._containerInstance))._elementRef.nativeElement.clientHeight; // in number
        if (event.srcElement.innerHeight <= this._defaults.maxHeight) { // if window height < _default.maxHeight
            this.config.height = Number(event.srcElement.innerHeight) - 20 + 'px';
            this.dialogRef.close();
            this.dialogRef = this.dialog.open(this.template, this.config);
        }
        else {
            this.resetDimensions();
            this.dialogRef.updateSize(this.config.width, this.config.height);
        }
    };

    resetDimensions = () => {
        this.config = { width: this.maxWidth, height: 'auto' };
    };

    closeDialog = () => {
        if (!this.dialogRef) return; // if dialog doesn't exist, return.
        this.closeClick.emit(this.referenceId);
        this.dialogRef.close();
    };

    onApplyClicked = () => {
        if (!this.dialogRef) return; // if dialog doesn't exist, return.
        this.applyClick.emit(this.referenceId);
        this.dialogRef.close();
    };
}

export interface ICustomDialogMessage {
    Heading: string;
    Content: string;
}



// WEBPACK FOOTER //
// ./src/app/widgets/custom-dialog/custom-dialog.component.ts